<template>
  <van-popover 
    ref="languagePopover"
    class="change-language"
    v-model="showPopover" 
    trigger="click" 
    theme="dark"
    placement="bottom-end"
    @select="handle" 
    @open="decoratePopover"
    :actions="list" 
    style="cursor: pointer;"
  >
    <template #reference>
      <van-button 
        class="language-selector van-button van-button--primary van-button--normal van-button--plain" 
        type="button" 
      >
        {{ currentLanguageText }}
      </van-button>
    </template>
  </van-popover>
</template>

<script>
import { getStoredLanguage, persistLanguage } from './language'

export default {
  name: 'change-language',
  data() {
    return {
      showPopover: false,
      list: [
        { key: 'zh-CN', text: '中文' }, // 中文
        { key: 'vi', text: 'Tiếng Việt' }, // 越南语
        { key: 'hi', text: 'हिन्दी' }, // 印地语
        { key: 'th', text: 'ไทย' }, // 泰语
        { key: 'ru', text: 'Русский' }, // 俄语
        { key: 'ko', text: '한국어' }, // 韩语
        { key: 'en', text: 'English' }, // 英语
        { key: 'jp', text: '日本語' }, // 日语
        { key: 'es', text: 'Español' },
        { key: 'fr', text: 'Français' },
        { key: 'de', text: 'Deutsch' },
        { key: 'it', text: 'Italiano' },
      ],
    }
  },
  computed: {
    currentLanguageText() {
      const langMap = {
        'zh-CN': '中文',
        'vi': 'Tiếng Việt',
        'hi': 'हिन्दी', 
        'th': 'ไทย',
        'ru': 'Русский',
        'ko': '한국어',
        'en': 'English',
        'jp': '日本語',
        'es': 'Español',
        'fr': 'Français',
        'de': 'Deutsch',
        'it': 'Italiano'
      }
      return langMap[this.$i18n.locale] || 'Language'
    }
  },
  methods: {
    decoratePopover() {
      this.$nextTick(() => {
        const popover = this.$refs.languagePopover
        const element = popover && popover.$refs.popover && popover.$refs.popover.$el
        if (element && element.classList) {
          element.classList.add('change-language-popover')
        }
      })
    },
    handle(value) {
      console.log('切换语言到:', value.key)
      
      const language = persistLanguage(value.key)
      this.$i18n.locale = language
      this.showPopover = false
    },
  },
  mounted() {
    console.log('当前语言:', this.$i18n.locale)
    console.log('可用语言包:', Object.keys(this.$i18n.messages))
    
    // 从 localStorage 恢复语言设置
    const savedLang = persistLanguage(getStoredLanguage())
    this.$i18n.locale = savedLang

    this.decoratePopover()
  }
}
</script>

<style lang="less">
.change-language .language-selector {
  box-sizing: border-box !important;
  min-width: 76px !important;
  height: 42px !important;
  padding: 0 18px !important;
  border: 1px solid rgba(226, 193, 125, 0.72) !important;
  border-radius: 10px !important;
  background: rgba(8, 10, 13, 0.78) !important;
  color: #f5d88d !important;
  font-size: 16px !important;
  font-weight: 700 !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.34) !important;
  backdrop-filter: blur(12px);
}

.change-language .language-selector:active,
.change-language .language-selector:hover {
  border-color: #f5d88d !important;
  background: rgba(31, 26, 18, 0.94) !important;
}

.change-language-popover.van-popover,
.change-language-popover {
  background: #0b0d10 !important;
  border: 1px solid rgba(226, 193, 125, 0.8) !important;
  border-radius: 14px !important;
  box-shadow: 0 16px 38px rgba(0, 0, 0, 0.7), inset 0 0 20px rgba(226, 193, 125, 0.1) !important;
  overflow: hidden !important;
}

.change-language-popover .van-popover__arrow {
  color: #0b0d10 !important;
}

.change-language-popover .van-popover__action {
  min-width: 132px !important;
  height: 48px !important;
  padding: 0 20px !important;
  color: #f5d88d !important;
  font-size: 15px !important;
  font-weight: 700 !important;
  background: #0b0d10 !important;
  border-bottom: 1px solid rgba(226, 193, 125, 0.16) !important;
}

.change-language-popover .van-popover__action:last-child { border-bottom: 0 !important; }
.change-language-popover .van-popover__action:active,
.change-language-popover .van-popover__action:hover { background: #211d16 !important; }
.change-language-popover .van-popover__action-text {
  color: #f5d88d !important;
  text-align: center !important;
  border-color: transparent !important;
}
.change-language-popover .van-popover__content {
  max-height: 70vh !important;
  overflow-y: auto !important;
}
</style>
